import Nullstack from 'nullstack';
export default function IconPlaylistOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-playlist-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14 14a3 3 0 1 0 3 3"
  }), "   ", Nullstack.element("path", {
    d: "M17 13v-9h4"
  }), "   ", Nullstack.element("path", {
    d: "M13 5h-4m-4 0h-2"
  }), "   ", Nullstack.element("path", {
    d: "M3 9h6"
  }), "   ", Nullstack.element("path", {
    d: "M9 13h-6"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}